import { executeStandardRequest } from '@musinsa/packages-http';
import { privateHttpClient } from '../httpClient';
import { accountInfoApiPath } from './apiPath';
import type { GetAccountInfoResponse } from './types';

export const getAccountInfo = () =>
  executeStandardRequest(() =>
    privateHttpClient.get<GetAccountInfoResponse>(accountInfoApiPath.getAccountInfo),
  );
